import React from "react";
import { message } from "antd";

import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteContent } from "src/modules/content/operations";
import { captureException } from "@sentry/react";

const DeleteView = (props) => {
    const { deleteContent, id } = props;

    const handleDelete = async () => {
        try {
            await deleteContent(id);
            message.success("Deleted!");
        } catch (err) {
            captureException(err)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteContent)(DeleteView);
